import type { ReactNode } from 'react';

interface SettingsSectionProps {
  title: string;
  description?: string;
  /** Optional control rendered to the right of the section title (e.g. a button). */
  action?: ReactNode;
  children: ReactNode;
}

/** A settings section: a small semibold title, an optional description, then its content. */
export function SettingsSection({ title, description, action, children }: SettingsSectionProps) {
  return (
    <section className="flex w-full flex-col">
      <div className={`mb-3 flex gap-4 ${action ? 'items-center justify-between' : 'flex-col gap-0.5'}`}>
        <div className="flex flex-col gap-0.5">
          <h2 className="text-xs font-semibold text-fg">{title}</h2>
          {description && <p className="text-xs leading-4.25 text-fg-tertiary">{description}</p>}
        </div>
        {action}
      </div>
      {children}
    </section>
  );
}
